import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-full-alert',
  templateUrl: './full-alert.component.html'
})
export class FullAlertComponent {
  @Input() isPrimary: boolean;
  @Input() isWarning: boolean;
  @Input() isMuted: boolean;
  @Input() title: string;

  constructor() {}
}
